export const homeLookupMap = {
  'home.yearBuilt': 'RatingInfo.YearBuilt',
  'home.replacementValue': 'ReplacementCost.ReplacementCost',
  'home.squareFootage': 'RatingInfo.SquareFootage',
  'home.numberOfStories': 'RatingInfo.NumberOfStories',
}

export default Object.keys(homeLookupMap)
